import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Box, Button, Grid, ThemeProvider, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import passengerApi from "../../api/passengerApi";
import { ContextUserInfo } from "../../Layout/MainLayout";
import customtheme from '../../themes';
import { useSelector } from 'react-redux';
import { RHFAutocomplete } from "../../Components/RHFAutocomplete";
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import CustomDateInput from "../../Components/CustomDateInput";
import DateObject from "react-date-object";
import RtlProvider from "../../Components/RtlProvider"
import helper from "../../helper";

import Excel from 'exceljs';
import { saveAs } from 'file-saver';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import { ImFileExcel } from "react-icons/im";
import moment from 'jalali-moment'
import './../../Styles/react-tagsinput.css'
import brokerGroupApi from "../../api/brokerGroupApi";

const SearchBroker = () => {
  const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
  const [brokerIDS, setBrokerIDS] = useState([]);
  const [groupNoS, setGroupNoS] = useState([]);
  const [data, setData] = useState([]);
  const [loadingExport, SetLoadingExport] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
const[opration,setOpration]=useState([]);

  //table state
  const [columnFilters, setColumnFilters] = useState(
    [],
  );
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const customization = useSelector((state) => state.customization);

  const schema = yup.object().shape({

  });
  const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({
    defaultValues: {
    oprationId:"1",
      brokerId: null,
      groupId: null,

    },
    resolver: yupResolver(schema),
  });
  //export to excel
  const workSheetName = 'Sheet1';
  const workbook = new Excel.Workbook();

  const getfilteritems = () => {

    const brokerId = watch("brokerId")
    const groupId = watch("groupId")

    let flightDateFromGregorian = null;
    if (watch("flightDateFrom")) {
      let flightDate = new DateObject({
        date: watch("flightDateFrom"),
        calendar: persian,
        locale: persian_fa
      });
 
      var flightDateFromStr = flightDate.year + '/' + flightDate.month.number + '/' + flightDate.day;
      flightDateFromGregorian = moment.from(flightDateFromStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
    }

    let flightDateToGregorian = null;
    if (watch("flightDateTo")) {
      let flightDate = new DateObject({
        date: watch("flightDateTo"),
        calendar: persian,
        locale: persian_fa
      });

      var flightDateToStr = flightDate.year + '/' + flightDate.month.number + '/' + flightDate.day;
      flightDateToGregorian = moment.from(flightDateToStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
    }
    var opetationId=watch("oprationId")? parseInt(watch("oprationId")):1;


    const paginationData = {
      "groupId": groupId,
      "brokerId": brokerId,
      "from": flightDateFromGregorian,
      "to": flightDateToGregorian,
      "orderBy": 0,
      "orderDescending": sorting.length > 0 ? sorting[0].desc : true,
      "pageNumber": pagination.pageIndex + 1,
      "pageSize": pagination.pageSize,
      "opration":opetationId,
    }
    return paginationData;
  }

  const fillOprationDropDown=()=>{
brokerGroupApi.GetOprationDropDown().then((res) => {
  const arr = helper.DictionayToList(res.data.data);
      setOpration(arr.map((o) => {
        return {
          id: o.key,
          label: o.value
        };
      }));
      })
      .catch((error1) => {
        console.log(error1);
        setIsError(true);
      })
     
  }



  const onSubmit = () => {   
    GetData();
  };
  useEffect(() => {
     fillOprationDropDown();
    GetBrokers();
  }, []);
  useEffect(() => {
    GetData();

  }, [
    columnFilters, //re-fetch when column filters change
    globalFilter, //re-fetch when global filter changes
    pagination.pageIndex, //re-fetch when page index changes
    pagination.pageSize, //re-fetch when page size changes
    sorting, //re-fetch when sorting changes

  ]);
  const GetBrokers = () => {
    passengerApi.GetBrokers().then((res) => {

      const arr = helper.DictionayToList(res.data.data);
      setBrokerIDS(arr.map((o) => {
        return {
          id: o.key,
          label: o.value
        };
      }));
    }
    )
      .catch((error) => {
        console.log(error);
      })
  }
  const GetExportData = (paginationData, totalcount, type) => {
    var clmns = [];
    var filename = '';
    if (type === 1) {
      filename = 'لیست کاروان'
      clmns = [
      { header: 'شرکت مجری', key: 'companyName' },
      { header: 'شرکت مجری عربی', key: 'arabicCompanyName' },
      { header: 'گروه قیمتی', key: 'priceGroup' },
      { header: 'هتل مکه', key: 'meccaHotel' },
      { header: 'هتل مدینه', key: 'medinaHotel' },
      // { header: 'استان', key: 'province' },
      { header: 'نام کارگزار', key: 'brokerName' },
      { header: 'کارگزار', key: 'brokerCode' },
      { header: 'گروه', key: 'groupName' },
      { header: 'تاریخ پرواز', key: 'flightDate' },
      { header: 'بالای 12 سال', key: 'adultCount' },
      { header: '7 تا 12 سال', key: 'youngCount' },
      { header: '2 تا7 سال', key: 'minorCount' },
      { header: 'زیر 2 سال', key: 'childCount' },
      { header: 'تعداد عوامل', key: 'headquartersagentsCount' },
      
      ]
    }

    paginationData.pageNumber = 1;
    paginationData.pageSize = totalcount;
    SetLoadingExport(true);
    brokerGroupApi.CustomFilter(paginationData)
      .then((outdata) => {

        const ExpData = outdata.data.data.items.map((rw) => { return rw.data })
        saveExcel(ExpData, clmns, filename);

      })
      .catch((error1) => {
        console.log(error1);
        setIsError(true);
      })
      .finally(() => {
        SetLoadingExport(false);
      })

  }
  const GetData = () => {
    const paginationData = getfilteritems();
    if (!data.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    brokerGroupApi.CustomFilter(paginationData)
      .then((data) => {
 
        setData(data.data.data.items);
        const rowcnt = data.data.data.totalCount;
        setRowCount(rowcnt);

      })
      .catch((error) => {
        console.log(error);
        setIsError(true);
      }).finally(() => {
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
      });
  };

  const handleExportClick = async (type) => {
    const paginationModel = getfilteritems();
    if (!data.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    brokerGroupApi.CustomFilter(paginationModel)
      .then((data) => {
        setData(data.data.data.items);
        const rowcnt = data.data.data.totalCount;
        setRowCount(rowcnt);
        GetExportData(paginationModel, data.data.data.totalCount, type);
      })
      .catch((error) => {
        console.log(error);
        setIsError(true);
      }).finally(() => {
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
      });
  }

  const columns = useMemo(
    () => [
      {
        accessorKey: 'recordNumber',
        header: '#',
        enableSorting: false,
      },
      {
        accessorKey: 'data.companyName',
        id: 'companyName',
        header: 'شرکت مجری',
        enableSorting: false,
      },
      {
        accessorKey: 'data.arabicCompanyName',
        id: 'arabicCompanyName',
        header: 'شرکت مجری عربی',
        enableSorting: false,
      },
      // {
      //   accessorKey: 'data.priceGroup',
      //   id: 'priceGroup',
      //   header: 'گروه قیمتی',
      //   enableSorting: false,
      // },
      {
        accessorKey: 'data.meccaHotel',
        id: 'meccaHotel',
        header: 'هتل مکه',
        enableSorting: false,
      },
      {
        accessorKey: 'data.medinaHotel',
        id: 'medinaHotel',
        header: 'هتل مدینه',
        enableSorting: false,
      },
      // {
      //   accessorKey: 'data.province',
      //   id: 'province',
      //   header: 'استان',
      //   enableSorting: false,
      // },
      {
        accessorKey: 'data.brokerName',
        id: 'brokerName',
        header: 'نام کارگزار',
        enableSorting: false,
      }, {
        accessorKey: 'data.brokerCode',
        id: 'brokerCode',
        header: 'کد کارگزار',
        enableSorting: false,
      },
      {
        accessorKey: 'data.groupName',
        id: 'groupName',
        header: 'گروه',
        enableSorting: false,
      },
      {
        accessorKey: 'data.flightDate',
        id: 'flightDate',
        header: 'تاریخ پرواز',
        enableSorting: true,
      },
      {
        accessorKey: 'data.adultCount',
        id: 'adultCount',
        header: 'بالای 12 سال',
        enableSorting: false,
      },
      {
        accessorKey: 'data.youngCount',
        id: 'youngCount',
        header: '7 تا 12 سال',
        enableSorting: false,
      },
      {
        accessorKey: 'data.minorCount',
        id: 'minorCount',
        header: '2 تا 7 سال',
        enableSorting: false,
      },

      {
        accessorKey: 'data.childCount',
        id: 'childCount',
        header: 'زیر 2 سال',
        enableSorting: false,
      },

      {
        accessorKey: 'data.headquartersagentsCount',
        id: 'headquartersagentsCount',
        header: 'تعداد عوامل',
        enableSorting: false,
      },

    ],
    [],
  );


  const table = useMaterialReactTable({
    columns,
    data,
    enableFilters: false,
    enableRowSelection: false,
    getRowId: (row) => row.phoneNumber,
    initialState: { showColumnFilters: true },
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    muiToolbarAlertBannerProps: isError
      ? {
        color: 'error',
        children: 'Error loading data',
      }
      : undefined,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    rowCount,
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      sorting,
    },

    muiTableHeadCellProps: {
      //simple styling with the `sx` prop, works just like a style prop in this example
      sx: {
        backgroundColor: 'rgb(113, 185, 172)',
        textAlign: 'right'
      },
    },
    muiTableBodyCellProps: ({ column }) => ({
      //conditionally style pinned columns
      sx: {
        textAlign: 'right',
      },
    }),
    muiTableBodyProps: {
      sx: {
        //stripe the rows, make odd rows a darker color
        '& tr:nth-of-type(odd) > td': {
          backgroundColor: '#f5f5f5',
        },
      },
    },
    enableRowActions: true,
    displayColumnDefOptions: {
      'mrt-row-actions': {
        header: ' ', //change header text
      },
    },
    positionActionsColumn: 'last',
    renderRowActions: ({ row }) => (
      <div dir="rtl">
        <Box >
      
        </Box>

      </div>
    ),

  });
  const fetchGroupsByBrokerId = (id) => {
    passengerApi.GetGroupsByBrokerID(id).then((res) => {
      const arr = helper.DictionayToList(res.data.data);
      setGroupNoS(arr.map((o) => {
        return {
          id: o.key,
          label: o.value
        };
      }));
    })
      .catch((err) => {
        console.log(err);
      });
  }

  const handleBrokerChanged = useCallback(async (id) => {
    setGroupNoS([]);
    if (id) {
      const groups = await fetchGroupsByBrokerId(id);
      setGroupNoS(groups);
    }
  }, []);

  const saveExcel = async (expData, columns, workBookName) => {
    try {
      const fileName = workBookName;

      // creating one worksheet in workbook
      const worksheet = workbook.addWorksheet(workSheetName);
      worksheet.views = [{ rightToLeft: true }];
      // add worksheet columns
      // each columns contains header and its mapping key from data
      worksheet.columns = columns;

      // updated the font for first row.
      worksheet.getRow(1).font = { bold: true };

      // loop through all of the columns and set the alignment with width.
      worksheet.columns?.forEach(column => {
        if (column.name === '')
          column.width = column.header.length + 5;
        column.alignment = { horizontal: 'center' };
      });

      // loop through data and add each one to worksheet
      expData?.forEach(singleData => {
        worksheet.addRow(singleData);
      });

      // loop through all of the rows and set the outline style.
      worksheet.eachRow({ includeEmpty: false }, row => {
        // store each cell to currentCell
        const currentCell = row._cells;

        // loop through currentCell to apply border only for the non-empty cell of excel
        currentCell.forEach(singleCell => {
          // store the cell address i.e. A1, A2, A3, B1, B2, B3, ...
          const cellAddress = singleCell._address;
          singleCell.numFmt = '@'
          // apply border
          // worksheet.getCell(cellAddress).border = {
          //   top: { style: 'thin' },
          //   left: { style: 'thin' },
          //   bottom: { style: 'thin' },
          //   right: { style: 'thin' }
          // };
        });
      });

      // write the content using writeBuffer
      const buf = await workbook.xlsx.writeBuffer();

      // download the processed file
      saveAs(new Blob([buf]), `${fileName}.xlsx`);
    } catch (error) {
      console.error('<<<ERRROR>>>', error);
      console.error('Something Went Wrong', error.message);
    } finally {
      // removing worksheet's instance to create new one
      workbook.removeWorksheet(workSheetName);
    }
  };


  return (
    <>
      <ThemeProvider theme={customtheme(customization)}>
        <RtlProvider>
          <Typography component="h1" variant="h5" mb={2} >
             لیست کاروان       </Typography>
          <form onSubmit={handleSubmit(onSubmit)} >
            <Grid container spacing={1}>
                <Grid item md={2} xs={7.5} >
                  <RHFAutocomplete
                    control={control}
                    options={opration}
                    name="oprationId"
                    placeholder="عملیات عمره"
                    style={{
                      border: "none",
                      padding: 0
                    }}
                  />
                </Grid>
                <Grid item md={2} xs={7.5} >
                  <RHFAutocomplete
                    control={control}
                    options={brokerIDS}
                    name="brokerId"
                    placeholder="شماره کاروان"
                    onChange={handleBrokerChanged}
                    style={{
                      border: "none",
                      padding: 0
                    }}
                  />
                </Grid>
                <Grid item md={1.5} xs={3.5} >
                  <RHFAutocomplete
                    control={control}
                    options={groupNoS}
                    name="groupId"
                    placeholder="شماره گروه"
                    style={{
                      border: "none",
                      padding: 0
                    }}
                  />
                </Grid>

                <Grid item md={1.5} xs={3.5}>

                  <Controller
                    control={control}
                    name="flightDateFrom"
                    rules={{ required: true }}
                    render={({
                      field: { onChange, name, value },
                      fieldState: { invalid, isDirty },
                    }) => (
                      <>
                        <DatePicker
                          value={value || ""}
                          onChange={(date) => {
                            onChange(date?.isValid ? date : "");
                          }}
                          format={"YYYY/MM/DD"}
                          calendar={persian}
                          locale={persian_fa}
                          calendarPosition="bottom-right"
                          render={<CustomDateInput label={" از تاریخ پرواز"} />}
                        />
                      </>
                    )}
                  />
                </Grid>
                <Grid item md={1.5} xs={3.5}>

                  <Controller
                    control={control}
                    name="flightDateTo"
                    rules={{ required: true }}
                    render={({
                      field: { onChange, name, value },
                      fieldState: { invalid, isDirty },
                    }) => (
                      <>
                        <DatePicker
                          value={value || ""}
                          onChange={(date) => {
                            onChange(date?.isValid ? date : "");
                          }}
                          format={"YYYY/MM/DD"}
                          calendar={persian}
                          locale={persian_fa}
                          calendarPosition="bottom-right"
                          render={<CustomDateInput label={"تا تاریخ پرواز"} />}
                        />
                      </>
                    )}
                  />
                </Grid>
             
              <Grid item xs={12} spacing={1} sx={{ marginTop: 0.5, marginBottom: 0.5 }}>
                <Button type="submit" variant="contained" color="primary"  >
                  جستجو
                </Button>
              </Grid>
            </Grid>
          </form>
        </RtlProvider>
        <div dir="rtl">
          <Box sx={{ textAlign: 'left', dir: 'rtl' }}>
            <Tooltip title="دانلود اکسل" placement="top">
              <IconButton disabled={loadingExport || isLoading} type="button" onClick={() => { handleExportClick(1) }}>
                {(loadingExport || isLoading) && <CircularProgress color="inherit" size="20px" sx={{ mx: '0.5rem' }} />}
                <ImFileExcel color='#04636E' />
              </IconButton>
            </Tooltip>

          </Box>
          <Typography ><Box sx={{ textAlign: 'left', dir: 'rtl' }}> {'تعداد نتایج' + ' : ' + rowCount} </Box></Typography>

          <Box sx={{ marginTop: 1 }} >
            <MaterialReactTable table={table} />
          </Box>
        </div>


      </ThemeProvider>
    </>
  )
}

export default SearchBroker